<div class="container">
  <h1>Visual Style Guide</h1>
  <p-tabMenu [model]="tabItems" [activeItem]="activeTabItem" styleClass="mb-4"></p-tabMenu>
  <router-outlet></router-outlet>
</div>
<p-toast key="styleGuideToast" position="top-right"></p-toast>
